import { default as SubscriptionsSection } from './SubscriptionsSection';

export default SubscriptionsSection;
